import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {
    Button, Modal,
    ModalBody as Body,
    ModalHeader as Header,
    ModalTitle as Title
} from "react-bootstrap";
import GroupedAction from "Entity/Collection/ListingSetting/GroupedAction";
import FormEmpty from "../../../Vendor/Components/FormEmpty";
import Property from "../../../Entity/Property";
import LoadingButton from "Components/Button/LoadingButton";

export interface _TransformModalProps {
    id: number
    showActionModals: {[key: string]: boolean|Property}
    handleShowActionModal: (groupedAction?: GroupedAction, actionFromMain?:boolean) => void
    fromMain: boolean
    handleShowMainActionModal: () => void
    selected: number[]
    actionModalFormIsLoading: boolean
    actionModalFormIsLoaded: boolean,
    setActionModalFormIsLoaded: (isLoaded: boolean) => void,
    handleActionModalOnResponse: () => void
    handleActionModalOnSuccess: () => void
    handleActionModalOnSubmit: () => void
}

const _TransformModal: FC<_TransformModalProps> = ({
                                                 id,
                                                 showActionModals,
                                                 handleShowActionModal,
                                                 fromMain,
                                                 handleShowMainActionModal,
                                                 selected,
                                                 actionModalFormIsLoading,
                                                 actionModalFormIsLoaded,
                                                 setActionModalFormIsLoaded,
                                                 handleActionModalOnResponse,
                                                 handleActionModalOnSuccess,
                                                 handleActionModalOnSubmit,
}) => {
    const {t} = useTranslation()

    return <Modal show={showActionModals.transform !== false} onHide={handleShowActionModal}>
        <Header closeButton={!fromMain}>
            <div className="modal-block-header">
                {fromMain && <i className="fa-solid fa-angle-left" onClick={handleShowMainActionModal}></i>}
                <Title>{t(`app.groupedActionTitle.transform`, {count: selected.length})}</Title>
            </div>
        </Header>
        <Body>
            <FormEmpty
                path={`/grouped-action/${id}/transform`}
                additionalData={{
                    items: selected,
                }}
                setIsLoaded={setActionModalFormIsLoaded}
                onResponse={handleActionModalOnResponse}
                onSubmit={handleActionModalOnSubmit}
                onSuccess={handleActionModalOnSuccess}
            >
                <div className="row justify-content-end align-items-center mb-3">
                    <div className="col-auto">
                        {!fromMain &&
                            <Button variant="secondary" className="me-3" onClick={() => {
                                handleShowActionModal()
                            }}>
                                {t('app.cancel')}
                            </Button>
                        }
                        <LoadingButton type="submit" isLoading={actionModalFormIsLoading} disabled={!actionModalFormIsLoaded}>
                            {t('app.groupedActionTitle.transform')}
                        </LoadingButton>
                    </div>
                </div>
            </FormEmpty>
        </Body>
    </Modal>
}

export default _TransformModal
